<template>
  <v-card max-width="600px" outlined>
    <v-card-title class="py-0">
      {{ $t('ELE0257') }}
    </v-card-title>
    <v-card-text>
      <v-row dense>
        <v-col class="px-1">
          <v-card outlined>
            <v-simple-table class="header-gray" fixed-header dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left v-data-table__divider">{{ $t('ELE0042') }}</th>
                    <th class="text-left">{{ $t('ELE0190') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="item in info1" :key="item.name">
                    <td class="v-data-table__divider">{{ item.name }}</td>
                    <td :class="item.class">{{ item.value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import DateUtil from '@/mixin/date-utils.js'

export default {
  name: 'InspDetail',

  mixins: [DateUtil],

  props: {
    inspDetail: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      info1: null,
    }
  },

  watch: {
    inspDetail: {
      handler(value) {
        this.setInspDetail(value)
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    setInspDetail(inspDetail) {
      this.info1 = []
      this.info1.push({ name: this.$t('ELE0437'), value: inspDetail.inspTimingDtlName, class: '' })
      this.info1.push({ name: this.$t('ELE0157'), value: inspDetail.cav, class: '' })
      this.info1.push({ name: this.$t('ELE0098'), value: inspDetail.numOfInsp, class: 'text-right' })
      this.info1.push({ name: this.$t('ELE0175'), value: inspDetail.inspQty, class: 'text-right' })
      this.info1.push({ name: this.$t('ELE0138'), value: this.toLocalDate(inspDetail.inspDate) })
      this.info1.push({ name: this.$t('ELE0154'), value: inspDetail.inspector, class: '' })
      this.info1.push({ name: this.$t('ELE0054'), value: inspDetail.remarks, class: '' })
    },
  },
}
</script>
